import { InvoiceUploadContextState } from './InvoiceUploadContext.types'
import { createContext } from 'react'

const InvoiceUploadContext = createContext<InvoiceUploadContextState>({} as InvoiceUploadContextState)

export default InvoiceUploadContext